import { localStorage } from 'dash-ui';
import { MediaFileTypesFilterEnum } from 'dash-common';

export function downloadMedia(
  mediaIds: string[],
  bulkParams?: {
    excludedIds?: string[];
    propertyId?: string;
    mediaFolderId?: string;
    searchText?: string;
    fileTypes?: MediaFileTypesFilterEnum[];
  }
): void {
  const bulkSearchParams = bulkParams
    ? new URLSearchParams({
        excludedIds: JSON.stringify(bulkParams.excludedIds),
        fileTypes: JSON.stringify(bulkParams.fileTypes || []),
        propertyId: bulkParams.propertyId || '',
        mediaFolderId: bulkParams.mediaFolderId || '',
        searchText: bulkParams.searchText || '',
      }).toString()
    : '';
  const mediaSearchParams = new URLSearchParams({
    mediaIds: JSON.stringify(mediaIds),
  }).toString();

  window.open(
    `${
      process.env['REACT_APP_REST']
    }/media/download?accessToken=${localStorage.getAccessToken()}&${mediaSearchParams}&${bulkSearchParams}`,
    '_self'
  );
}

export function downloadAllMediaInProperty(propertyId: string): void {
  window.open(
    process.env['REACT_APP_REST'] +
      `/media/download-all-media-in-property?accessToken=${localStorage.getAccessToken()}&propertyId=${propertyId}`,
    '_self'
  );
}

export function downloadDocumentFile(file: {
  publicUrl: string;
  name: string;
}): void {
  const link = document.createElement('a');
  link.href = file.publicUrl;
  link.setAttribute('download', file.name);
  link.setAttribute('target', '_blank');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
